import VApp from './VApp';

VApp.install = function install(Vue) {
  Vue.component(VApp.name, VApp);
};

export default VApp;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VApp/index.js
// module id = IcMm
// module chunks = 0